<template>
    <div class="microlearning-navigation-buttons">
        <TotemButton
            :disabled="isFirstSection"
            @click="selectSection(-1)"
            icon="arrow-left"
            size="small"
            color="secondary"
            class="microlearning-navigation-buttons__previous-button"
            :label="$t('Microlearning.navigation_previous')"
            :fullWidth="isMobileView"
        />
        <TotemButton
            :disabled="isLastSection"
            @click="selectSection(1)"
            icon="arrow-right"
            size="small"
            color="secondary"
            iconPosition="right"
            class="microlearning-navigation-buttons__next-button"
            :label="$t('Microlearning.navigation_next')"
            :fullWidth="isMobileView"
        />
    </div>
</template>
<script>
    import microLearningHelper from 'components/shared/mixins/microLearningHelper'
    import routeHelper from 'components/shared/mixins/routeHelper'

    export default {
        name: 'MicroLearningNavigationButtons',
        mixins: [ microLearningHelper, routeHelper ],
        props: {
            isCollectionCoursePage: {
                type: Boolean,
                default: false
            },
            collectionAllCourses: Array,
            currentCourseId: Number
        },
        methods: {
            selectSection (value) {
                if (value === 1 && this.isCollectionCoursePage && !this.isLastCollectionSection && this.isLastMicroLearningSection) {
                    this.selectCollectionPart(1)
                } else if (value === -1 && this.isCollectionCoursePage && !this.isFirstCollectionSection && this.isFirstMicroLearningSection) {
                    this.selectCollectionPart(-1)
                } else {
                    this.selectMicroLearningSectionOnly(value)
                }
            },
            async selectMicroLearningSectionOnly (value) {
                const scrollPosition = document.documentElement.scrollTop
                const nextSectionIndex = (this.getCurrentSectionIndex() + value)
                const nextSection = this.microLearningSections[nextSectionIndex]
                this.$router.replace({ name: this.getCorrectRouteForMicroLearning, query: { element: nextSection.elementId } })
                await this.$store.dispatch('MicroLearning/assignMicroLearningSection', nextSection)
                if (nextSection.type === 'video') {
                    await this.$store.dispatch('Courses/changeCourseVideo', nextSection)
                    this.$emit('reInitializeVideo')
                }
                document.documentElement.scrollTop = scrollPosition
            },
            selectCollectionPart (value) {
                const nextSectionIndex = this.coursePositionInArray + value
                const nextSection = this.collectionAllCourses[nextSectionIndex]
                this.$router.push(this.getRouteToCourse(nextSection))
            }
        }
    }
</script>

<style lang="scss" scoped>
    .microlearning-navigation-buttons {
        display: flex;
        flex-direction: row;
        margin: 20px 0 0;
        gap: 5px;

        [class*="mobile"] {
            margin: 20px 0px 10px;
            gap: 10px;        
        }
    }
</style>
